var Uploader = require('uploader');

module.exports = function() {
	// Setup the Uploader, if included on the page.
	if ($("#uploader").length > 0) {
		new Uploader(uploaderOptions.clarify());
	}
};